// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4547":"55b68748","4644":"a6c01f21","5893":"1849cb6f","6717":"55b68748","6804":"1849cb6f"}[chunkId] + ".chunk.css";
};